import React from 'react'
import noop from 'lib/function/noop'
import type { DropdownBehaviourDispatchAction } from './DropdownBehaviourState'
import type DropdownBehaviourState from './DropdownBehaviourState'
import { DROPDOWN_BEHAVIOUR_INITIAL_STATE } from './DropdownBehaviourState'

export const DropdownBehaviourStateContext = React.createContext<DropdownBehaviourState>(DROPDOWN_BEHAVIOUR_INITIAL_STATE)
export const DropdownBehaviourDispatchContext = React.createContext<React.Dispatch<DropdownBehaviourDispatchAction>>(noop)
